import { useCallback } from 'react';

import type { PaywallIntentParams } from './types';

class Content {
	static paywallIntent: PaywallIntentParams | undefined = undefined;
}

export const useNeedsToShowPaywall = () => {
	const setNeedsToShowPaywall = useCallback(
		(state: PaywallIntentParams | undefined) => {
			Content.paywallIntent = state;
		},
		[]
	);

	return {
		paywallIntent: Content.paywallIntent,
		setNeedsToShowPaywall,
	};
};
